import React from 'react';
import { MessageCircle, Phone, ShoppingBag } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

const FloatingContactButtons = () => {
  const phoneNumber = '21628889555';
  const whatsappLink = `https://wa.me/${phoneNumber}`;
  const phoneLink = `tel:+${phoneNumber}`;
  const { toggleCart, getTotalItems } = useCart();
  const totalItems = getTotalItems();

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col space-y-4">
      {/* Bouton Panier */}
      <button
        onClick={toggleCart}
        className="relative bg-primary text-primary-foreground p-4 rounded-full shadow-lg hover:bg-opacity-90 transition-all"
        aria-label="Ouvrir le panier"
      >
        <ShoppingBag size={24} />
        {totalItems > 0 && (
          <span className="absolute -top-1 -right-1 bg-accent text-accent-foreground text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
            {totalItems}
          </span>
        )}
      </button>

      {/* WhatsApp */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-success text-success-foreground p-4 rounded-full shadow-lg hover:bg-opacity-90 transition-all"
        aria-label="Contactez-nous sur WhatsApp"
      >
        <MessageCircle size={24} />
      </a>

      {/* Appel téléphonique */}
      <a
        href={phoneLink}
        className="bg-accent text-accent-foreground p-4 rounded-full shadow-lg hover:bg-opacity-90 transition-all"
        aria-label="Appelez-nous"
      >
        <Phone size={24} />
      </a>
    </div>
  );
};

export default FloatingContactButtons;
